import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ApiResponse, useFetchRun } from "../Hooks/useFetch";
import React from "react";
import { BASE_URL } from "../Store/Action";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const otp = searchParams.get("q");

  useEffect(() => {
    if (!otp) {
      setError("유효하지 않은 링크입니다.");
    }
  }, [otp]);

  const { loading, executeFetch } = useFetchRun<ApiResponse<any>>({
    url: `${BASE_URL}/user/update-password`,
    method: "PUT",
    body: {
      otp_code: otp,
      new_password: password,
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // 비밀번호 유효성 검사
    if (password !== confirmPassword) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (password.length < 6) {
      setError("비밀번호는 최소 6자 이상이어야 합니다.");
      return;
    }

    try {
      const rst = await executeFetch();
      if (rst.meta.code !== 200) {
        setError(rst.meta.message);
      } else {
        setSuccess(true);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
        setError("");
      }
    } catch (err) {
      setError(err.message || "비밀번호 변경 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-[70vh] p-5">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md p-8 bg-white rounded-lg shadow-md"
      >
        <h1 className="text-2xl font-semibold text-center mb-8 text-gray-800">
          비밀번호 재설정
        </h1>

        {error && (
          <div className="mb-5 p-3 bg-red-50 text-red-600 rounded-md text-center">
            {error}
          </div>
        )}

        {success && (
          <div className="mb-5 p-3 bg-green-50 text-green-600 rounded-md text-center">
            비밀번호가 성공적으로 변경되었습니다.
          </div>
        )}

        <div className="mb-5">
          <label
            htmlFor="password"
            className="block mb-2 font-medium text-gray-700"
          >
            변경할 비밀번호
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="새 비밀번호를 입력하세요"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div>

        <div className="mb-6">
          <label
            htmlFor="confirmPassword"
            className="block mb-2 font-medium text-gray-700"
          >
            비밀번호 확인
          </label>
          <input
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="비밀번호를 다시 입력하세요"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div>

        <button
          type="submit"
          disabled={!otp || success}
          className={`w-full py-3 px-4 text-white font-semibold rounded-md transition ${
            !otp || success
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-500 hover:bg-blue-600"
          }`}
        >
          비밀번호 변경하기
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
